import { render, staticRenderFns } from "./queryZhiYe.vue?vue&type=template&id=38f7c324&scoped=true&"
import script from "./queryZhiYe.vue?vue&type=script&lang=js&"
export * from "./queryZhiYe.vue?vue&type=script&lang=js&"
import style0 from "./queryZhiYe.vue?vue&type=style&index=0&id=38f7c324&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7c324",
  null
  
)

export default component.exports